import PropTypes from 'prop-types';
import { Container, Alert, AlertTitle } from '@mui/material';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
import LoadingScreen from '../components/LoadingScreen';
import { PATH_AUTH, PATH_DASHBOARD } from '../routes/paths';
// components
// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  // Fully authenticated users → redirect to dashboard
  if (isAuthenticated === true) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  // Registration verification page
  if (isAuthenticated === 'verify') {
    // Allow access to pages where user needs to verify their account
    return <>{children}</>;
  }

  // Login OTP/PIN verification page
  if (isAuthenticated === 'verify_login') {
    // Allow access to OTP verification page
    return <>{children}</>;
  }

  // Any other unauthenticated access
  return <Navigate to={PATH_AUTH.login} />;
}
